<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2024-01-02 08:50:58
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="小区" prop="commId">
                <el-cascader :options="options" :props="props" v-model="caasaderarr" collapse-tags clearable></el-cascader>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="viewData.title" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" :rows="2" v-model="viewData.desc" />
            </el-form-item>
            <el-form-item label="首页缩略图">
                <image-upload ref="imageUpload2"
                          v-if="showUpload2"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸216*140,请自己处理好宽高比例`"
                          :image-list="imageDefaultList2"
                          autoCropWidth="330"
                          autoCropHeight="330"
                          :maxNumber="3"
                          @updateImg="onUpdateImg2($event)"></image-upload>
            </el-form-item>

            <el-form-item label="显示类型" prop="show_type">
                <el-select
                        v-model="viewData.show_type"
                        clearable
                        filterable
                        placeholder="请选择分类"
                >
                <el-option label="大封面图上下排版" :value="1" />
                <el-option label="小封面图上下排版" :value="2" />
                <el-option label="左右排版" :value="3" />
                </el-select>
            </el-form-item>
           
            <el-form-item label="封面图">
                <image-upload ref="imageUpload"
                          v-if="showUpload"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸330*330,请自己处理好宽高比例`"
                          :image-list="imageDefaultList"
                          autoCropWidth="330"
                          autoCropHeight="330"
                          :maxNumber="3"
                          @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="分类">
                <el-select
                        v-model="viewData.cate_id"
                        clearable
                        filterable
                        placeholder="请选择分类"
                >
                <el-option v-for="item in optionCate"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <vue-ueditor-wrap v-if="showUpload" ref="ueditor" v-model="viewData.content" :config="ueconfig"></vue-ueditor-wrap>
            </el-form-item>
            <el-form-item label="发布时间">
                <el-date-picker v-model="viewData.publish_at"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="发布时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
                <el-date-picker v-model="viewData.end_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="来源">
                <el-input v-model="viewData.source" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="是否置顶">
                <el-switch
                    v-model="viewData.is_top"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="发布状态">
                <el-switch
                    v-model="viewData.status"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/news";
import newsCate from "@/api/tianzheng/newsCate";
import dylbanner from "@/api/tianzheng/dylbanner";
import Qu from "@/api/tianzheng/Qu";
import VueUeditorWrap from 'vue-ueditor-wrap'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            thumbList: [],
            thumbList2:[],
            imageDefaultList: "",
            imageDefaultList2:"",
            showUpload:false,
            showUpload2:false,
            optionCate: [],
            optionList: [],
            props: { multiple: true },
            ueconfig: {
                initialFrameHeight: 300,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关键配置：提高弹窗层级
                zIndex: 9000,  // el-dialog默认z-index是2000+，设置更高的值
                catchRemoteImageEnable: true, // 抓取远程图片
                serverUrl: 'https://xcx.tzwyfw.com/ueditor/controller.php',
                withCredentials: true,
            },
            viewData: {
                id:'',
                cate_id:'',
                title: "",
                commId: "0",
                show_type: "",
                content: "",
                source: "",
                publish_at: "",
                end_at: "",
                sort: 0,
                is_top: 1,
                status: 1,
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                show_type:[
                {
                        required: true,
                        message: "请选择显示类型",
                        trigger: "blur",
                    },
                ]
            },
        };
    },
    components: {
        Pagination,
        ImageUpload,
        VueUeditorWrap
    },
    created() {
        this.getSelectCity()
        this.getSelectCate()
        this.getSelectCateNew()
    },
    methods: {
        onUpdateImg (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        onUpdateImg2 (val) {
            let thumbList2 = [];
            val.forEach((ele, idx) => {
                thumbList2.push(ele.path);
            });
            this.thumbList2 = thumbList2;
        },
        // 获取下拉列表
        getSelectCate () {
            newsCate.select({}).then(res => {
                if (res.code == 200) {
                this.optionCate = res.result;
                this.optionCate.unshift({
                    id:0,
                    name:'请选择分类'
                })
                }
            })
        },
        // 获取下拉列表
        getSelectCateNew() {
            dylbanner.select({}).then(res => {
                if (res.code == 200) {
                    this.options = res.result;
                    this.optionCate = res.result;
                    // this.optionCate.unshift({
                    //     id:-1,
                    //     name:'请选择'
                    // })
                }
            })
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            this.resetForm()
            let that = this
            this.caasaderarr = [],
            this.viewData = {
                id:'',
                cate_id:0,
                title: "",
                commId: "0",
                caarr: [],
                show_type: "",
                content: "",
                source: "",
                publish_at: this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
                end_at: "",
                sort: 0,
                is_top: 1,
                status: 1,
            }
            this.showUpload = true;
            this.showUpload2 = true;
            this.thumbList2 = [];
            this.thumbList = [];
            if (this.$refs.imageUpload2) {
                this.$refs.imageUpload2.clearFileList();
                this.imageDefaultList2 = "";
            }
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        that.caasaderarr = res.result.caarr
                        if (that.viewData.thumb.length > 0) {
                            let imgList = [];
                            let thumb_arr = that.viewData.thumb;
                            thumb_arr.forEach((ele, index) => {
                                let obj = {
                                    name: ele,
                                    path: ele,
                                    url: that.$publicData.imgUrl + ele,
                                }
                                imgList.push(obj);
                            })
                            // 回显图
                            that.imageDefaultList = JSON.stringify(imgList);
                        };
                        if (that.viewData.shouye_thumb!=""&&that.viewData.shouye_thumb != null) {
                            let imgList2 = [];
                            let obj = {
                                name: that.viewData.shouye_thumb,
                                path: that.viewData.shouye_thumb,
                                url: that.$publicData.imgUrl + that.viewData.shouye_thumb,
                            }
                            imgList2.push(obj);
                            // 回显图
                            that.imageDefaultList2 = JSON.stringify(imgList2);
                            console.log(that.imageDefaultList2);
                        };
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            this.viewData.thumb = this.thumbList;
            if(this.thumbList2.length >0){
                this.viewData.shouye_thumb = this.thumbList2[0]
            }
            console.log(this.viewData)
            if(this.viewData.thumb.length<1){
                this.$message.warning("请上传封面图")
                return
            }
            this.viewData.caarr = this.caasaderarr;
            let count = 0
            for (let i = 0; i < this.options.length; i++) {
                const item = this.options[i];
                for (let j = 0; j < item.children.length; j++) {
                    const subItem = item.children[j];
                    for (let n = 0; n < subItem.children.length; n++) {
                        count ++;
                    }
                }
            }
            let is_jituan = 0
            if (this.caasaderarr.length >= count) {
                is_jituan = 1
            }  
            if (this.viewData.end_at == null || this.viewData.end_at == undefined || this.viewData.end_at == "") {
                this.viewData.end_at = '2099-12-31 23:59:59'
            }
            this.viewData.is_jituan = is_jituan
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(that.viewData.id){
						// 编辑
						fetch.edit(that.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(that.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.$refs["ruleForm"].resetFields();
            this.showUpload = false;
            this.viewData.publish_at = this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
        },
        formatDate (tt, fmt) {
        if (null == tt || "" == tt) return "";
        var date = new Date(tt);
        let o = {
            "M+": date.getMonth() + 1, // 月份
            "d+": date.getDate(), // 日
            "h+": date.getHours(), // 小时
            "m+": date.getMinutes(), // 分
            "s+": date.getSeconds(), // 秒
            S: date.getMilliseconds() // 毫秒
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
            );
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
            }
        }
        return fmt;
        },
        },
};
</script>

<style lang="scss" scoped>
</style>
